import DistributionChart from 'src/javascripts/components/charts/DistributionChart';
import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';

export default class PortfoliosInvestmentsIndex {

  constructor() {}

  render() {

    $('.underlying-radio').on('change', function(ev, suggestion) {
      let val = $(this).val();
      let underlying = $(this).is(':checked');
      let url = new URL(window.location.href);
      url.searchParams.set('underlying', underlying ? 'true' : 'false');
      Turbo.visit(url.toString());
    })

    // Distribution chart
    let hasDist = $('.distributionChart').length !== 0
    let c3NotLoaded = typeof $('.distributionChart').data('c3-chart') === 'undefined';
    if ((hasDist) && (c3NotLoaded)) {
      $('.distributionChart').each(function() {
        let $el = $(this);
        let $chart = new DistributionChart($el);
        $.when( $chart.getData() )
         .then( data => $chart.render(data) );
      })
    }

    ResearchFiltering();

  }

}
